export const PUSH_PERMISSION_UI_ENV =
  "REACT_APP_PUSH_PERMISSION_UI_ENABLED";

const KNOWN_PERMISSIONS = new Set(["default", "granted", "denied"]);

function defaultNotificationApi() {
  try {
    return typeof window !== "undefined" ? window.Notification : null;
  } catch {
    return null;
  }
}

export function isPushPermissionUiEnabled(environment = process.env) {
  const value = environment?.[PUSH_PERMISSION_UI_ENV];
  return (
    typeof value === "string" && value.trim().toLowerCase() === "true"
  );
}

export function getNotificationPermissionState(
  notificationApi = defaultNotificationApi()
) {
  try {
    return KNOWN_PERMISSIONS.has(notificationApi?.permission)
      ? notificationApi.permission
      : "unsupported";
  } catch {
    return "unsupported";
  }
}

function normalizedRequestResult(permission) {
  if (permission === "granted") {
    return {
      status: "permission_granted_pending_registration",
      permission,
    };
  }
  if (permission === "default") {
    return { status: "permission_request_dismissed", permission };
  }
  if (permission === "denied") {
    return { status: "permission_denied", permission };
  }
  return {
    status: "permission_request_unavailable",
    permission: "unsupported",
  };
}

export function requestNotificationPermissionFromUserGesture(
  notificationApi = defaultNotificationApi()
) {
  const currentPermission = getNotificationPermissionState(notificationApi);
  if (currentPermission === "granted" || currentPermission === "denied") {
    return Promise.resolve(normalizedRequestResult(currentPermission));
  }
  if (
    currentPermission !== "default" ||
    typeof notificationApi?.requestPermission !== "function"
  ) {
    return Promise.resolve({
      status: "permission_request_unavailable",
      permission: "unsupported",
    });
  }

  let requestResult;
  try {
    requestResult = notificationApi.requestPermission();
  } catch {
    return Promise.resolve({
      status: "permission_request_failed",
      permission: "default",
    });
  }

  return Promise.resolve(requestResult)
    .then(normalizedRequestResult)
    .catch(() => ({
      status: "permission_request_failed",
      permission: "default",
    }));
}
